import { Component, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseTunnelObject } from '../../model/base-tunnel-object';
import { CONFIG_CONTEXT } from '../../../../enum/config-context.enum';
import { KitchenInstallationComponent } from '../../kitchen/kitchen-installation/kitchen-installation.component';
import { StorageInstallationComponent } from '../../storage/storage-installation/storage-installation.component';
import { BathroomTunnelInstallationComponent } from '../../bathroom/bathroom-tunnel-installation/bathroom-tunnel-installation.component';
import { CarpentryTunnelInstallationComponent } from '../../carpentry/carpentry-tunnel-installation/carpentry-tunnel-installation.component';
import { BathroomHbmInstallationComponent } from '../../bathroom-hbm/bathroom-hbm-installation/bathroom-hbm-installation.component';

@Component({
  selector: 'ng-casto-base-installation',
  templateUrl: './base-installation.component.html',
})
export class BaseInstallationComponent extends BaseTunnelObject {
  @ViewChild('installationContainer', { read: ViewContainerRef, static: true })
  private installationContainer!: ViewContainerRef;

  private static readonly DEFAULT_PLACEHOLDER_IMAGE_SRC = 'assets/img/models/alisma-gris.jpg';
  protected placeholderImageSrc: string = BaseInstallationComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;

  protected subscribeToObservable() {
    this.subscriptionList.push(
      this.tunnelNavigationStore.getCurrentStep().subscribe(step => {
        if (step) {
          this.placeholderImageSrc = step.placeholderImageSrc ?? BaseInstallationComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;
        }
      }),
      this.tunnelNavigationStore.getCurrentContext().subscribe(context => {
        if (context) this.initBodyContentFromContext(context);
      })
    );
  }

  private initBodyContentFromContext(context: CONFIG_CONTEXT) {
    switch (context) {
      case CONFIG_CONTEXT.KITCHEN:
        this.loadComponent(KitchenInstallationComponent);
        break;
      case CONFIG_CONTEXT.STORAGE:
        this.loadComponent(StorageInstallationComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM_V2:
        this.loadComponent(BathroomTunnelInstallationComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM:
        this.loadComponent(BathroomHbmInstallationComponent);
        break;
      case CONFIG_CONTEXT.CARPENTRY:
        this.loadComponent(CarpentryTunnelInstallationComponent);
        break;
        default:
        break;
    }
  }

  private loadComponent(component: Type<any>): void {
    this.installationContainer.clear();
    this.installationContainer.createComponent(component);
  }

  protected readonly CONFIG_CONTEXT = CONFIG_CONTEXT;
}
